import { motion } from "motion/react";

export function ContentCard({
  children,
  className = "",
  gradient,
}) {
  const defaultGradient =
    "linear-gradient(160deg, rgba(16, 24, 40, 0.5) 0%, rgba(16, 24, 40, 0.3) 100%)";

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`relative rounded-2xl item-border border-[#1e2939] p-6 md:p-8 lg:p-12 ${className}`}
      style={{
        backgroundImage: gradient || defaultGradient,
      }}
    >
      {children}
    </motion.div>
  );
}
